const getLocation = (...locations: (string | number | undefined)[]) => {
  return locations.filter(Boolean).join(', ');
};

export { getLocation };
